import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {TerritorialAuthorityService} from './territorial-authority.service';

/**
 * Провайдер территориальных органов ростеха
 */

@Injectable()
export class TerritorialAuthorityProvider extends BaseProvider<TerritorialAuthorityInterface[]> {
    public defaultValue = [];

    constructor(
        service: TerritorialAuthorityService
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения
         */
        this.data$.next(this.defaultValue);
        this.updateData();
    }

    getById(id: number): TerritorialAuthorityInterface {
        return this.data$.getValue().find(item => +item.id === +id);
    }
}


export interface TerritorialAuthorityInterface {
    id: number;
    name: string;           // Наименование органа ростеха
    region: string;         // Регион, к которому относится орган
    code: string;
    address: string;
}
